// extracted by mini-css-extract-plugin
export default {"formHolder":"PasswordCreateInput_formHolder__cCrk-","formfield":"PasswordCreateInput_formfield__HuUYD"};